<template>
  <div class="login">
    <div class="resto" @click="closeModal" />
    <div class="text-center container data-login">
      <div class="flex-box">
        <button class="btn border-none shadow-none background-transparent" @click="$emit('close')">
          <img src="~@/assets/icons/equis.webp" width="20" alt="" />
        </button>
      </div>
      <div class="cuadro">
        <div class="titulo">
          {{ $t('modalUnirseHabitacion.titulo') }}
        </div>
        <div class="subtitulo">
          {{ $t('modalUnirseHabitacion.subtitulo') }}
        </div>
        <div class="row align-items-center justify-content-center">
          <div class="col-12">
            <div>
              {{ $t('input.field.nombreApellidos') }}
            </div>
            <div v-for="error in nombreYapellidosFormErrors" :key="error" class="col-12 error">
              {{ error }}
            </div>
            <input v-model="nombreYapellidos" type="text" :placeholder="$t('input.field.nombreApellidos')" />
          </div>
          <div class="col-12">
            <div>
              {{ $t('input.field.correo') }}
            </div>
            <div v-for="error in emailFormErrors" :key="error" class="col-12 error">
              {{ error }}
            </div>
            <input v-model.trim="email" type="email" :placeholder="$t('input.field.correo')" />
          </div>
          <div class="col-12">
            <div v-for="error in telefonoFormErrors" :key="error" class="col-12 error">
              {{ error }}
            </div>
            <div>
              {{ $t('input.field.telefono') }}
            </div>
            <input v-model="telefono" type="number" :placeholder="$t('input.field.telefono')" />
          </div>
          <div class="col-12">
            {{ $t('input.field.numeroPlazas') }}
            <div v-for="error in plazasFormErrors" :key="error" class="col-12 error">
              {{ error }}
            </div>
            <input
              v-model="plazas"
              type="number"
              min="1"
              max="100"
              step="1"
              :placeholder="$t('input.field.numeroPlazas')" />
          </div>
          <div class="col-12">
            {{ $t('input.field.observaciones') }}
            <textarea v-model.trim="observaciones" />
          </div>
          <div v-if="backEndError" class="col-12 error">
            {{ backEndError }}
          </div>
          <div class="col-5" @click="closeModal">
            <button class="btn">
              {{ $t('botones.volver') }}
            </button>
          </div>
          <div class="col-5" @click="botonSubmit">
            <button class="btn">
              {{ $t('botones.enviar') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref } from 'vue';
  import * as AlertUtils from '@/services/utils/AlertUtils';
  import useFormValidator from '@/helpers/useFormValidator';
  import useRegexConstants from '@/helpers/useRegexConstants';
  import { CONFLICT } from '@/services/utils/HttpStatus';
  import { useI18n } from 'vue-i18n';
  import ViajesGrupoApiService from '@/services/api/skiandnight/ViajesGrupoApiService';

  export default {
    name: 'GruposListaEsperaModal',
    props: {
      viajeId: {
        type: String,
        default: null,
        required: true,
      },
    },
    emits: ['close'],

    setup(props, { emit }) {
      /**
       * clase utilidad para validaciones
       */
      const { validateInput } = useFormValidator();
      /**
       * Clase utilidad constantes regex
       */
      const { REGEX_VALID_NOMBRE } = useRegexConstants();
      // formulario
      const nombreYapellidos = ref('');
      const email = ref('');
      const telefono = ref('');
      const plazas = ref(1);
      const observaciones = ref('');
      const backEndError = ref(null);
      const { t } = useI18n();

      function buildVGListaEsperaDTO() {
        return {
          viajeId: props.viajeId,
          nombre: nombreYapellidos.value,
          email: email.value,
          telefono: telefono.value,
          plazas: plazas.value,
          observaciones: observaciones.value,
        };
      }
      /**
       * Se ejecuta al aceptar el formulario
       *
       * @returns {Promise<void>}
       */
      const botonSubmit = async () => {
        backEndError.value = null;
        const isValidForm = validateForm();
        if (isValidForm) {
          const vgListaEsperaDTO = buildVGListaEsperaDTO();
          try {
            await ViajesGrupoApiService.agregarListaEspera(vgListaEsperaDTO);
            AlertUtils.alertSuccess(t('general.listaEsperaSuccess'));
            closeModal();
          } catch (error) {
            let errorMsg = t('general.listaEsperaError');
            if (error.response && error.response.status === CONFLICT.code) {
              errorMsg = error.response.data;
            }
            backEndError.value = errorMsg;
          }
        }
      };

      // errores formulario
      const nombreYapellidosFormErrors = ref([]);
      const emailFormErrors = ref([]);
      const telefonoFormErrors = ref([]);
      const plazasFormErrors = ref([]);

      /**
       * Valida los campos del formulario, dejando la lista de errores
       *
       * @returns {boolean} true si form inputs son validos
       */
      function validateForm() {
        nombreYapellidosFormErrors.value = validateInput(
          nombreYapellidos.value,
          'text',
          true,
          50,
          null,
          REGEX_VALID_NOMBRE
        );
        emailFormErrors.value = validateInput(email.value, 'email', true);
        telefonoFormErrors.value = validateInput(telefono.value, 'tel', true, null, 9);
        plazasFormErrors.value = validateInput(plazas.value, 'text', true);

        return (
          nombreYapellidosFormErrors.value.length === 0 &&
          emailFormErrors.value.length === 0 &&
          telefonoFormErrors.value.length === 0 &&
          nombreYapellidosFormErrors.value.length === 0 &&
          plazasFormErrors.value.length === 0
        );
      }

      const closeModal = function close() {
        emit('close');
      };

      return {
        // valores formulario
        nombreYapellidos,
        email,
        telefono,
        plazas,
        observaciones,
        // errores validaciones inputs formulario
        nombreYapellidosFormErrors,
        emailFormErrors,
        telefonoFormErrors,
        plazasFormErrors,
        // errores backend
        backEndError,
        // funciones
        botonSubmit,
        closeModal,
      };
    },
  };
</script>

<style lang="css" scoped>
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }
  .resto {
    height: 100%;
  }

  .container {
    margin: 0;
  }
  .titulo {
    font-size: 1.2rem;
    font-weight: bold;
  }
  .subtitulo {
    padding: 1rem;
    font-size: 1rem;
  }

  .login {
    width: 100%;
    position: fixed;
    position: -webkit-sticky;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 1010;
    background-color: rgba(0, 0, 0, 0.377);
    height: 100vh;
  }
  .data-login {
    position: absolute;
    margin: auto;
    bottom: 0;
    background-color: #fff;
    padding-top: 1rem;
    padding-bottom: 3rem;
    border-radius: var(--bs-border-radius-xxl) var(--bs-border-radius-xxl) 0 0;
    max-width: 100%;
  }

  .cuadro {
    padding-top: 2rem;
    padding-bottom: 2rem;
    border-radius: var(--bs-border-radius-xl);
    max-width: 30rem;
    margin: auto;
    background-image: linear-gradient(78deg, var(--bs-primary), #454a79);
    color: #fff;
  }

  input {
    width: 80%;
    padding: 0.4rem 1rem 0.4rem 1rem;
    font-size: 0.8rem;
    border-radius: var(--bs-border-radius-lg);
    margin-bottom: 1rem;
    color: var(--bs-primary);
  }

  textarea {
    width: 80%;
    padding: 0.4rem 1rem 0.4rem 1rem;
    font-size: 0.8rem;
    border-radius: var(--bs-border-radius-lg);
    margin-bottom: 1rem;
    color: var(--bs-primary);
  }

  .btn {
    background-color: var(--bs-secondary);
    border-radius: var(--bs-border-radius-xl);
    padding: 0.4rem 2rem 0.4rem 2rem;
    font-size: 0.8rem;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  }

  .error {
    font-size: 0.8rem;
    color: red;
    margin-bottom: 0.5rem;
  }

  .flex-box {
    display: flex;
    justify-content: flex-end;
  }
  .background-transparent {
    background: transparent;
  }

  @media only screen and (min-width: 962px) {
    .data-login {
      background-color: unset;
      bottom: 25vh;
      position: sticky;
      border-radius: var(--bs-border-radius-xxl);
      max-width: 40rem;
    }
  }
</style>
